function NavItem({ href, onClick, children, active, className = "" }) {
    const isButton = onClick && !href;
    const classes = ["nav-item", active && "nav-item--active", className].filter(Boolean).join(" ");

    if (isButton) {
        return (
            <button type="button" className={classes} onClick={onClick}>
                <span className="side-nav__label">{children}</span>
            </button>
        );
    }

    return (
        <a href={href || "#"} className={classes} onClick={onClick}>
            <span className="side-nav__label">{children}</span>
        </a>
    );
}

export default NavItem;
